import Alpine from "alpinejs";
import { AssistantTranscriptService } from "@src/js/services/assistantTranscriptService";
import { getQueryParam } from "@src/js/utils/http";
Alpine.data("assistantTranscript", () => ({
    transcript: {},
    notifications: [],
    async init() {
        const shareKey = getQueryParam('shareKey');
        const sessionId = getQueryParam('sessionId');
        this.transcript = await AssistantTranscriptService.getBySessionId(shareKey, sessionId);
        console.log("Transcript loaded:", this.transcript);
        // transform the chat messages of the transcript to ChatNotification format
        this.transcript.chatMessages.forEach((msg) => {
            const notification = {
                type: msg.role === 'assistant'
                    ? 'is-warning'
                    : msg.role === 'user'
                        ? 'is-info'
                        : 'is-light', // fallback or default
                message: msg.content,
            };
            this.notifications.push(notification);
        });
    },
}));
